package co.gul.ui.theme

import org.jetbrains.compose.web.css.Color

object Palette {
    val primary = Color("#1a6b4a")
    val onPrimary = Color("#ffffff")
    val primaryContainer = Color("#b7f0d1")
    val onPrimaryContainer = Color("#002114")
    val secondary = Color("#4a6358")
    val onSecondary = Color("#ffffff")
    val secondaryContainer = Color("#ccece0")
    val surface = Color("#f8faf9")
    val surfaceVariant = Color("#dce8e2")
    val surfaceContainer = Color("#ecf2ee")
    val onSurface = Color("#191c1a")
    val onSurfaceVariant = Color("#3f4d47")
    val outline = Color("#6f7e77")
    val outlineVariant = Color("#bdc9c3")
    val background = Color("#f8faf9")
    val error = Color("#ba1a1a")
    val scrim = Color("rgba(0,0,0,0.32)")

    val text = onSurface
    val textMuted = onSurfaceVariant
    val border = outlineVariant
    val accent = primary
    val tag = primaryContainer
    val tagText = onPrimaryContainer
}